export interface Ramp { name: string; stops: [number, [number, number, number]][] }

export const RAMPS: Record<string, Ramp> = {
  rdylgn: { name: 'Red–Yellow–Green', stops: [
    [0, [142, 58, 42]], [.28, [190, 150, 90]], [.5, [247, 244, 199]],
    [.72, [122, 183, 102]], [1, [16, 92, 52]]] },
  viridis: { name: 'Viridis', stops: [
    [0, [68, 1, 84]], [.25, [59, 82, 139]], [.5, [33, 145, 140]],
    [.75, [94, 201, 98]], [1, [253, 231, 37]]] },
  magma: { name: 'Magma', stops: [
    [0, [0, 0, 4]], [.25, [80, 18, 123]], [.5, [182, 54, 121]],
    [.75, [251, 136, 97]], [1, [252, 253, 191]]] },
  turbo: { name: 'Turbo', stops: [
    [0, [48, 18, 59]], [.2, [54, 158, 230]], [.45, [85, 222, 126]],
    [.7, [248, 201, 58]], [1, [122, 4, 3]]] },
  gray: { name: 'Grayscale', stops: [[0, [8, 10, 12]], [1, [245, 248, 250]]] },
};

export function rampAt(stops: Ramp['stops'], t: number): [number, number, number] {
  const x = Math.max(0, Math.min(1, t));
  for (let i = 1; i < stops.length; i++) {
    const [b, cb] = stops[i]!;
    if (x <= b) {
      const [a, ca] = stops[i - 1]!;
      const f = (b - a) ? (x - a) / (b - a) : 0;
      return [0, 1, 2].map((k) => Math.round(ca[k]! + (cb[k]! - ca[k]!) * f)) as [number, number, number];
    }
  }
  return stops[stops.length - 1]![1];
}
